module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/karol-gulatowski-5c6583c1f978b054d5aff96afb501cd3.webp";